import React from 'react';
import VideoSlide from '../../body/VideoSlide';
import { PDFdownloadButton, pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const pdf = pdfFiles.strategiesPart1[5];

const HouseholdRules = () => {
  return (
    <div className='text-left p-4'>
      <VideoAndShowPDFAfter pdfFile={pdf} vidSrc={1194418634} />
    </div>
  );
};

export default HouseholdRules;
